
export default {
    articles: {
        count: 0,
        display: [],
    },
    userServices: [], //services at current specialist
    booking: {
        active: false,
        specialistId: null,
        currentStep: 1,
        servicesNumber: 1,
        availabilityDates: null,
        selectedStartTime: null,
        selectedEndTime: null,
        selectedDayIndex: 0,
        summary: {
            money: 0,
            credits: 0,
            services: 0
        },
        loading: false
    },
    metadata: {
        standard_service_duration: 0,
        standard_break_duration: 0,
    },
    packages: [],
    reviews: {
        all: [],
        count: 0,
        display: [],
        canAdd: true,
        grade: null,
        graph: [],
    },
    modals: {
        addFeedback: false,
        buyService: false,
        buyPackage: false,
        moreFeedbacks: false,
        description: false,
        anytimeMeeting: false,
        anytimeMeetingInvite: {
            active: false,
            invite: null
        },
    },
    specialist: null, //+ profile_data
    isLoading: false,
    isLoadingAvailabilityDates: false,

    /* Transactions */
    transactions           : [],
    transactionsAppearance : 'list', // list, grid
    transactionsEnd        : false,
    transactionsLoading    : false,
}
